<template>
  <form-actions class="header sticky-header">
    <h1 slot="left">{{title}}</h1>
    <nav v-if="links" slot="left">
      <i class="icon-square-right text-muted text-size-mini"></i>&nbsp;
      <template v-for="(label, link, index) in links"><template v-if="index"> | </template><a :href="`#${link}`" v-text="label"></a></template>
    </nav>
    <div class="clearfix mt-20 mb-20"><slot></slot></div>
  </form-actions>
</template>

<style type="text/less" lang="less">
  @import "~package-common-vuejs/src/less/colors.less";

  .header {
    background: @body-bg;
    border-bottom: 1px solid @hr-border;
    margin-bottom: 20px;
    position: sticky;
    top: 50px;
    z-index: @zindex-dropdown - 1;
    nav {
      margin-top: -15px;
    }
  }
</style>

<script>
  export default {
    props: {
      title: String,
      links: Object,
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/FormStickyHeader.vue